// Map representation coordinates (projected standard scale)
export const CITY_COORDINATES = {
  "New Delhi": { lat: 28.6139, lng: 77.209, label: "DEL" },
  Gurgaon: { lat: 28.4595, lng: 77.0266, label: "GGN" },
  Mumbai: { lat: 19.076, lng: 72.8777, label: "BOM" },
  Bangalore: { lat: 12.9716, lng: 77.5946, label: "BLR" },
  Chennai: { lat: 13.0827, lng: 80.2707, label: "MAA" },
  Hyderabad: { lat: 17.385, lng: 78.4867, label: "HYD" },
  Kolkata: { lat: 22.5726, lng: 88.3639, label: "CCU" },
  Patna: { lat: 25.5941, lng: 85.1376, label: "PAT" },
  Ahmedabad: { lat: 23.0225, lng: 72.5714, label: "AMD" },
  Pune: { lat: 18.5204, lng: 73.8567, label: "PNQ" },
};

export const INITIAL_SHIPMENTS = [
  {
    awb: "JPSY10012026",
    orderId: "ORD-554219",
    lrn: "LRN-998811",
    senderMobile: "9876543210",
    receiverMobile: "9123456789",
    senderName: "Apex Electronics Ltd",
    senderAddress:
      "Plot 42, Electronic City Phase 1, Bangalore, Karnataka - 560100",
    receiverName: "Rohan Sharma",
    receiverAddress:
      "Flat 402, Sea Breeze Apartments, Bandra West, Mumbai, Maharashtra - 400050",
    originCity: "Bangalore",
    destinationCity: "Mumbai",
    originPincode: "560100",
    destinationPincode: "400050",
    weight: 4.5,
    dimensions: "30x20x15 cm",
    status: "in_transit",
    currentLocation: {
      lat: 15.3173,
      lng: 75.7139,
      name: "Hubli Supply Chain Gateway Hub",
    }, // midway
    serviceType: "Express Parcel",
    paymentType: "Prepaid",
    codAmount: 0,
    bookingDate: "2026-06-27 10:30 AM",
    estimatedDelivery: "2026-06-30",
    transportType: "flight",
    routeCoordinates: [
      {
        lat: 12.9716,
        lng: 77.5946,
        name: "Bangalore Fulfillment Center",
        isCompleted: true,
      },
      {
        lat: 15.3173,
        lng: 75.7139,
        name: "Hubli Supply Chain Gateway Hub",
        isCompleted: true,
      },
      {
        lat: 18.5204,
        lng: 73.8567,
        name: "Pune Regional Sorter",
        isCompleted: false,
      },
      {
        lat: 19.076,
        lng: 72.8777,
        name: "Mumbai Delivery Center",
        isCompleted: false,
      },
    ],
    milestones: [
      {
        status: "booked",
        title: "Shipment Booked",
        location: "Bangalore FC",
        timestamp: "2026-06-27 11:00 AM",
        description: "Seller booked shipment and printed shipping label.",
        completed: true,
      },
      {
        status: "dispatched",
        title: "Manifested & Dispatched",
        location: "Bangalore FC",
        timestamp: "2026-06-27 04:30 PM",
        description:
          "Consignment sorted and dispatched from Bangalore Fulfillment Center.",
        completed: true,
      },
      {
        status: "in_transit",
        title: "In Transit",
        location: "Hubli Hub",
        timestamp: "2026-06-28 09:15 AM",
        description:
          "Package arrived at Hubli Supply Chain Gateway Hub for onward sorting.",
        completed: true,
      },
      {
        status: "reached_hub",
        title: "Reached Sorting Hub",
        location: "Pune Regional Sorter",
        timestamp: "Pending",
        description: "Awaiting arrival scan at Pune Regional Sorter Hub.",
        completed: false,
      },
      {
        status: "out_for_delivery",
        title: "Out for Delivery",
        location: "Mumbai Delivery Center",
        timestamp: "Pending",
        description: "Assigned to delivery agent for doorstep delivery.",
        completed: false,
      },
      {
        status: "delivered",
        title: "Delivered",
        location: "Mumbai Address",
        timestamp: "Pending",
        description: "Successfully handed over to consignee with signature.",
        completed: false,
      },
    ],
  },
  {
    awb: "JPSY20012026",
    orderId: "ORD-991024",
    lrn: "LRN-224411",
    senderMobile: "9876543210",
    receiverMobile: "9345678912",
    senderName: "BioCare Organics",
    senderAddress:
      "Sector 5, Guindy Industrial Estate, Chennai, Tamil Nadu - 600032",
    receiverName: "Priya Reddy",
    receiverAddress:
      "House 12-A, Jubilee Hills Rd 4, Hyderabad, Telangana - 500033",
    originCity: "Chennai",
    destinationCity: "Hyderabad",
    originPincode: "600032",
    destinationPincode: "500033",
    weight: 1.2,
    dimensions: "15x15x10 cm",
    status: "delivered",
    currentLocation: {
      lat: 17.385,
      lng: 78.4867,
      name: "Hyderabad Jubilee Hills",
    },
    serviceType: "Express Parcel",
    paymentType: "COD",
    codAmount: 1450,
    bookingDate: "2026-06-25 09:00 AM",
    estimatedDelivery: "2026-06-28",
    transportType: "truck",
    routeCoordinates: [
      {
        lat: 13.0827,
        lng: 80.2707,
        name: "Chennai Central Sorter",
        isCompleted: true,
      },
      {
        lat: 14.4426,
        lng: 79.9864,
        name: "Nellore Transit Point",
        isCompleted: true,
      },
      {
        lat: 17.385,
        lng: 78.4867,
        name: "Hyderabad Main Hub",
        isCompleted: true,
      },
    ],
    milestones: [
      {
        status: "booked",
        title: "Shipment Booked",
        location: "Chennai Hub",
        timestamp: "2026-06-25 09:30 AM",
        description: "Shipment pickup scheduled.",
        completed: true,
      },
      {
        status: "dispatched",
        title: "Package Dispatched",
        location: "Chennai Central Sorter",
        timestamp: "2026-06-25 06:00 PM",
        description: "In-scanned and dispatched on linehaul truck.",
        completed: true,
      },
      {
        status: "in_transit",
        title: "In Transit",
        location: "Nellore",
        timestamp: "2026-06-26 02:00 AM",
        description: "Transit vehicle checked out at Nellore Toll Plaza.",
        completed: true,
      },
      {
        status: "reached_hub",
        title: "Reached Sorting Hub",
        location: "Hyderabad Main Hub",
        timestamp: "2026-06-26 11:30 PM",
        description: "Shipment received at Hyderabad Main Hub and sorted.",
        completed: true,
      },
      {
        status: "out_for_delivery",
        title: "Out for Delivery",
        location: "Hyderabad Jubilee Hills Center",
        timestamp: "2026-06-28 08:30 AM",
        description:
          "Dispatched with executive Suresh Kumar (Ph: +91 9900112233).",
        completed: true,
      },
      {
        status: "delivered",
        title: "Delivered Successfully",
        location: "Hyderabad Consignee Address",
        timestamp: "2026-06-28 01:15 PM",
        description:
          "Delivered. Cash on Delivery (COD) of ₹1450 collected and digitally acknowledged.",
        completed: true,
      },
    ],
  },
  {
    awb: "JPSY30012026",
    orderId: "ORD-708819",
    lrn: "LRN-456782",
    senderMobile: "9876543210",
    receiverMobile: "9870001234",
    senderName: "TrendVibe Apparel",
    senderAddress: "Warehouse Block D, Okhla Phase 3, New Delhi - 110020",
    receiverName: "Amit Gupta",
    receiverAddress:
      "Tower B, Flat 1004, DLF Phase 3, Gurgaon, Haryana - 122002",
    originCity: "New Delhi",
    destinationCity: "Gurgaon",
    originPincode: "110020",
    destinationPincode: "122002",
    weight: 0.8,
    dimensions: "20x15x5 cm",
    status: "out_for_delivery",
    currentLocation: {
      lat: 28.4595,
      lng: 77.0266,
      name: "Gurgaon Sector 24 Sorter",
    },
    serviceType: "Express Parcel",
    paymentType: "Prepaid",
    codAmount: 0,
    bookingDate: "2026-06-28 03:00 PM",
    estimatedDelivery: "2026-06-29",
    transportType: "bike",
    routeCoordinates: [
      {
        lat: 28.6139,
        lng: 77.209,
        name: "Delhi Okhla Center",
        isCompleted: true,
      },
      {
        lat: 28.4595,
        lng: 77.0266,
        name: "Gurgaon DLF Hub",
        isCompleted: true,
      },
    ],
    milestones: [
      {
        status: "booked",
        title: "Shipment Booked",
        location: "Delhi Okhla Center",
        timestamp: "2026-06-28 03:15 PM",
        description:
          "Shipment booked. Scheduled for immediate same-day warehouse dispatch.",
        completed: true,
      },
      {
        status: "dispatched",
        title: "Dispatched to Delivery Center",
        location: "Delhi Okhla Center",
        timestamp: "2026-06-28 07:00 PM",
        description:
          "Transferred via hyper-local courier network to Gurgaon DLF Hub.",
        completed: true,
      },
      {
        status: "reached_hub",
        title: "Reached local Delivery Hub",
        location: "Gurgaon DLF Hub",
        timestamp: "2026-06-29 06:45 AM",
        description: "Arrived at destination delivery facility and bag opened.",
        completed: true,
      },
      {
        status: "out_for_delivery",
        title: "Out for Delivery",
        location: "Gurgaon DLF Hub",
        timestamp: "2026-06-29 08:30 AM",
        description:
          "Assigned to hyper-local runner Mukesh Patil (Ph: +91 9871100223). OTP generated.",
        completed: true,
      },
      {
        status: "delivered",
        title: "Delivered",
        location: "Gurgaon Address",
        timestamp: "Pending",
        description: "Consignee signature required.",
        completed: false,
      },
    ],
  },
  {
    awb: "JPSY40012026",
    orderId: "ORD-887112",
    lrn: "LRN-331209",
    senderMobile: "9876543210",
    receiverMobile: "9001122334",
    senderName: "Vedic Herbs India",
    senderAddress:
      "Salt Lake Sector V, Block EP, Kolkata, West Bengal - 700091",
    receiverName: "Sanjay Kumar Paswan",
    receiverAddress: "Chanakya Colony near High Court, Patna, Bihar - 800001",
    originCity: "Kolkata",
    destinationCity: "Patna",
    originPincode: "700091",
    destinationPincode: "800001",
    weight: 2.8,
    dimensions: "25x25x20 cm",
    status: "booked",
    currentLocation: { lat: 22.5726, lng: 88.3639, name: "Kolkata Sorter Hub" },
    serviceType: "Part Truckload",
    paymentType: "Prepaid",
    codAmount: 0,
    bookingDate: "2026-06-29 08:00 AM",
    estimatedDelivery: "2026-07-02",
    transportType: "truck",
    routeCoordinates: [
      {
        lat: 22.5726,
        lng: 88.3639,
        name: "Kolkata Sorter Hub",
        isCompleted: true,
      },
      { lat: 23.674, lng: 86.9524, name: "Asansol Hub", isCompleted: false },
      {
        lat: 25.5941,
        lng: 85.1376,
        name: "Patna Central Delivery Center",
        isCompleted: false,
      },
    ],
    milestones: [
      {
        status: "booked",
        title: "Shipment Booked",
        location: "Kolkata Sorter Hub",
        timestamp: "2026-06-29 08:15 AM",
        description:
          "Shipment successfully booked. Scheduled for evening container pickup.",
        completed: true,
      },
      {
        status: "dispatched",
        title: "Manifested & Dispatched",
        location: "Kolkata Sorter Hub",
        timestamp: "Pending",
        description:
          "Sorting in progress. To be dispatched on vehicle scheduled for 18:00 hrs.",
        completed: false,
      },
      {
        status: "in_transit",
        title: "In Transit",
        location: "Asansol Hub",
        timestamp: "Pending",
        description: "Awaiting linehaul dispatch scan.",
        completed: false,
      },
      {
        status: "reached_hub",
        title: "Reached Destination Hub",
        location: "Patna Central Hub",
        timestamp: "Pending",
        description: "In-scanning at sorting center.",
        completed: false,
      },
      {
        status: "out_for_delivery",
        title: "Out for Delivery",
        location: "Patna Local Gateway",
        timestamp: "Pending",
        description: "Dispatched for last-mile delivery.",
        completed: false,
      },
      {
        status: "delivered",
        title: "Delivered",
        location: "Patna Delivery Address",
        timestamp: "Pending",
        description: "Pending successful delivery handover.",
        completed: false,
      },
    ],
  },
];

export const MOCK_TRANSACTIONS = [
  {
    id: "TXN-9988221",
    date: "2026-06-28 11:30 AM",
    type: "credit",
    amount: 15000,
    description: "UPI Wallet Top Up - HDFC Bank",
    status: "success",
  },
  {
    id: "TXN-9988222",
    date: "2026-06-28 01:15 PM",
    type: "debit",
    amount: 450,
    description: "Shipping charges paid for AWB JPSY30012026",
    status: "success",
  },
  {
    id: "TXN-9988223",
    date: "2026-06-27 05:00 PM",
    type: "debit",
    amount: 1250,
    description: "Shipping charges paid for AWB JPSY10012026",
    status: "success",
  },
  {
    id: "TXN-9988224",
    date: "2026-06-25 10:00 AM",
    type: "debit",
    amount: 320,
    description: "Shipping charges paid for AWB JPSY20012026",
    status: "success",
  },
  {
    id: "TXN-9988225",
    date: "2026-06-24 04:45 PM",
    type: "credit",
    amount: 1450,
    description: "COD Remittance received for order ORD-129088",
    status: "success",
  },
];

// Helper to calculate realistic shipping fares
export function calculateMockRates(req) {
  const originFirstDigit = parseInt(req.originPincode[0] || "1");
  const destFirstDigit = parseInt(req.destinationPincode[0] || "1");
  const isSameZone = originFirstDigit === destFirstDigit;

  let baseRate = 60; // short range small pack base
  let weightFactor = Math.ceil(req.weight) * 25;

  if (!isSameZone) {
    baseRate = 120; // cross zone base
    weightFactor = Math.ceil(req.weight) * 45;
  }

  // Adjust by service type
  let multiplier = 1.0;
  let etaDays = isSameZone ? 1 : 3;

  if (
    req.serviceType === "Part Truckload" ||
    req.serviceType === "Full Truckload"
  ) {
    multiplier = 1.8;
    etaDays = isSameZone ? 2 : 5;
  } else if (req.serviceType === "International") {
    multiplier = 3.5;
    etaDays = 7;
  }

  const baseFare = Math.round((baseRate + weightFactor) * multiplier);
  const fuelSurcharge = Math.round(baseFare * 0.12); // 12% surcharge
  const codCharges = req.paymentType === "COD" ? 50 : 0; // Standard COD collection fee
  const gst = Math.round((baseFare + fuelSurcharge + codCharges) * 0.18); // 18% GST

  const total = baseFare + fuelSurcharge + codCharges + gst;

  return {
    baseFare,
    fuelSurcharge,
    codCharges,
    gst,
    total,
    etaDays,
  };
}
